import { render } from "./AdminSwapOpsView.vue?vue&type=template&id=3fa2c669&scoped=true"
import script from "./AdminSwapOpsView.vue?vue&type=script&lang=js"
export * from "./AdminSwapOpsView.vue?vue&type=script&lang=js"

import "./AdminSwapOpsView.vue?vue&type=style&index=0&id=3fa2c669&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa2c669"]])

export default __exports__